<template>
  <el-container style="width: 100%; height: 100%; min-width: 80%; ">
    <el-header class="header" style="height: 63px;">
      <el-container style="justify-content: space-between; height:100%;">
        <h1>
          <a
            @click="home"
            style="color: #9d9d9d; cursor:pointer; user-select:none; font-size:1.6rem;"
          >字体转换服务</a>
        </h1>
        <ul class="nav">
          <li>
            <el-dropdown style="line-height: 63px;">
              <span class="el-dropdown-link">
                <span style="margin-right: 20px;">
                  <i class="el-icon-user"></i>
                </span>
                Hello,{{ username }}!
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="goFontrecord">历史查询</el-dropdown-item>
                <el-dropdown-item @click.native="goUpdate">修改密码</el-dropdown-item>
                <el-dropdown-item @click.native="gologin">切换用户</el-dropdown-item>
                <el-dropdown-item @click.native="gologin">退出登录</el-dropdown-item>
                <!-- <el-dropdown-item @click.native="gotest">测试</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </li>
        </ul>
      </el-container>
    </el-header>
    <keep-alive include="search,fchoose">
      <router-view @audit_back="audit_b" @contentToggle="contToggle" style="margin-top:20px"></router-view>
    </keep-alive>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      boolean1: false,
      boolean2: false,
      username: '',
      activeName: this.$route.name
    }
  },

  mounted() {
    this.username = this.$store.state.username
    if (this.$route.name == 'audit') {
      this.boolean1 = true
    }
    if (this.$route.name == 'update') {
      this.boolean2 = true
    }
  },

  methods: {
    contToggle(a) {
      this.boolean1 = a
    },
    audit_b(a) {
      this.boolean1 = a
    },

    home() {
      // this.boolean1 = false
      // this.boolean2 = false
      this.$router.push({
        path: '/layout/transform',
        name: 'transform'
      })
    },
    gologin() {
      this.boolean1 = false
      this.boolean2 = false
      this.$store.commit('token', '')
      this.$store.commit('userId', '')
      this.$router.push({
        path: '/',
        name: 'login'
      })
    },
    goUpdate() {
      this.boolean1 = false
      this.boolean2 = true
      this.$router.push({
        path: '/layout/update'
      })
    },
    gotest() {
      this.$router.push({
        path: '/layout/test'
      })
    },
    handleClick(tab, event) {
      if (tab.name === 'fmatrix') {
        // 触发‘配置管理’事件
        this.gofm()
      } else if (tab.name === 'fchoose') {
        // 触发‘用户管理’事件
        this.gofc()
      } else {
        this.goco()
      }
    },
    gofm() {
      this.$router.push({
        path: '/layout/fmatrix'
      })
    },
    gofc() {
      this.$router.push({
        path: '/layout/fchoose'
      })
    },
    goco() {
      this.$router.push({
        path: '/layout/collect'
      })
    },
    goFontrecord() {
      this.$router.push({
        path: '/layout/record'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  background-color: #333;
  height: 63px;
  line-height: 63px;
  color: #9d9d9d;
  /* border-radius: 10px 10px 0 0; */
}
.tab {
  position: fixed;
  left: 0rem;
  top: 10rem;
}

* /deep/ li {
  list-style: none;
  text-align: center;
  line-height: 30px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #9d9d9d;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-icon-user {
  font-size: 16px;
  color: azure;
}
</style>

<style>
* {
  margin: 0;
  padding: 0;
}

a {
  color: rgb(51, 122, 183);
  text-decoration: none;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 3px;
}
.outContainer {
  -ms-overflow-style: none;
}
</style>
